<template>
  <div class="cont-main">
    <e-form
      ref="refForm1"
      :config="formConfig"
      :column="formColumn1"
      :data.sync="detailData.formData"
      :disabled="isSelfDisabled"
    />
    <e-form
      v-show="false"
      :config="formConfig2"
      :column="formColumn2"
      :data.sync="detailData.formData"
      :disabled="isSelfDisabled"
    />
    <div class="box-y-scroll" :style="{ 'max-height': maxHeight }">
      <div class="table-main">
        <div class="link-total-detail">
          <el-link v-if="id" class="" type="warning" @click="openPopupVerifyGoodsDetail">
            制造明细
          </el-link>
          <el-link v-if="id" class="m-l-10" type="success" @click="itemCopy"> 引用新增 </el-link>
        </div>
        <div class="form-5">
          <div>
            <el-input
              v-model="detailData.formData.bill_tax_rate"
              placeholder="税率"
              size="mini"
              :style="{ width: '110px' }"
            >
              <template slot="prepend">税率</template>
              <template slot="suffix">%</template>
            </el-input>
          </div>
          <template v-if="detailData.formData.bill_tax_rate">
            <el-button class="m-l-2" type="primary" size="mini" @click="setTaxRate"
              >还原未税</el-button
            >
          </template>
          <el-checkbox
            class="m-l-10"
            v-model="detailData.formData.has_freight"
            :disabled="isSelfDisabled"
            >是否含运</el-checkbox
          >
        </div>
        <TableSale
          v-if="loaded"
          tableTitle="bom表清单"
          :parent="null"
          :data.sync="detailData.tableSaleData"
          :disabled="isSelfDisabled"
          :statusName="detailData.formData.status_str"
          :shuilv="detailData.formData.bill_tax_rate"
        />
      </div>
      <div v-if="isShowTiaoKuan" class="cont-form">
        <div class="form-title">合同条款</div>
        <e-form
          ref="refForm4"
          class="form-list"
          :config="formConfig4"
          :column="formColumn4"
          :data.sync="detailData.pact_bill"
          :disabled="isSelfDisabled"
        />
      </div>
    </div>

    <div class="total-main">
      <span v-for="(item, index) in formColumn3" :key="index" class="total-item">
        <span>{{ item.title }}:</span>
        <span class="total-item-price">{{ detailData.formData[item.field] }}</span>
        <span>{{ item.suffix }}</span>
      </span>
    </div>

    <div class="flex flex-y-center flex-x-end b-t-1 p-t-10">
      <el-button v-if="!isSelfDisabled" type="primary" size="mini" @click="detailSave(true)">
        {{ id ? '保存核算单' : '创建核算单' }}
      </el-button>
      <el-button v-if="!isSelfDisabled" type="success" size="mini" @click="detailPush">
        生成合同
      </el-button>
      <el-button
        v-if="id && isFuZe && detailData.formData.status_str === '待审核'"
        type="success"
        size="mini"
        @click="detailPass"
      >
        审核通过
      </el-button>
      <el-button
        v-if="
          id &&
          isFuZe &&
          (detailData.formData.status_str === '待审核' ||
            detailData.formData.status_str === '进行中')
        "
        type="danger"
        size="mini"
        @click="detailReject"
      >
        审核驳回
      </el-button>
      <el-button v-if="id && isChuangJian" type="default" size="mini" @click="detailPrint">
        打印核算单
      </el-button>
    </div>

    <!-- 弹窗-增改客户 isLockSaler -->
    <b-popup-customer
      v-if="isShowPopupCustomer"
      :show.sync="isShowPopupCustomer"
      :id="activeCustomerId"
      :salerId="detailData.formData.saler_id"
      :salerName="detailData.formData.saler_name"
      :isLockJieDaiStatus="!activeCustomerId"
      @success="customerUpdate"
    />

    <!-- 弹窗-制造明细 -->
    <b-popup-verify-goods-detail
      v-if="isShowPopupVerifyGoodsDetail"
      :show.sync="isShowPopupVerifyGoodsDetail"
      :id="id"
    />
  </div>
</template>

<script>
import math from './math'
export default {
  components: {
    TableSale: () => import('./table-sale')
  },
  props: {
    isShowTiaoKuan: {
      type: Boolean,
      default: false
    },
    id: {
      type: [String, Number],
      default: ''
    },
    isChuangJian: {
      type: Boolean,
      refault: false
    },
    isFuZe: {
      type: Boolean,
      refault: false
    }
  },
  data() {
    return {
      loaded: false,
      isDetailPush: false,
      isDetailPrint: false,
      customerKeyword: '',
      formConfig: {
        width: '303px' // 277px
      },
      formConfig2: {
        width: '180px'
      },
      formConfig5: {
        width: '120px'
      },
      formConfig4: {
        inline: false,
        width: '100%'
      },
      formColumn1: [
        {
          type: 'date',
          title: '销售日期',
          field: 'bill_date',
          required: true,
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd'
        },
        {
          type: 'text',
          title: '销售单号',
          field: 'bill_code',
          placeholder: '自动生成',
          disabled: true
        },
        {
          type: 'select',
          title: '业务员',
          field: 'saler_id',
          options: []
        },
        {
          type: 'select',
          title: '客户',
          field: 'company_id',
          hide: false,
          options: [],
          optionDo: { title: '编辑', fn: () => {} },
          emptyDo: { title: '新增客户', fn: () => {} },
          filterable: true,
          remote: true,
          remoteMethod: (val) => {
            this.customerKeyword = val
            this.getCustomerList(true)
          },
          fnChange: () => {
            setTimeout(() => {
              this.customerChoose()
            }, 200)
          }
        },
        {
          type: 'select',
          title: '开单公司',
          field: 'saler_company_name',
          options: this.$constant.companyList
        },
        {
          type: 'select',
          title: '订单类型',
          field: 'ding_dan_lei_xing',
          options: [
            {
              key: '销售订单',
              val: '销售订单'
            },
            {
              key: '来料加工订单',
              val: '来料加工订单'
            }
          ]
        },
        {
          type: 'date',
          title: '交货日期',
          field: 'jiao_huo_ri_qi',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          required: true
        },
        {
          type: 'upload_file',
          title: '附件文档',
          field: 'fu_jian_list',
          isDelete: true
        },
        {
          type: 'text',
          title: '项目名称',
          field: 'xiang_mu_ming_cheng',
        },
        {
          type: 'text',
          title: '单据备注',
          field: 'bill_remark',
        }
        // {
        //   type: 'number',
        //   title: '税率',
        //   field: 'bill_tax_rate',
        //   suffix: '%',
        //   fnChange: () => {
        //     math.totalFormData(this.detailData) // 计算-表格汇总计算
        //   }
        // }
      ],
      formColumn2: [
        {
          type: 'number',
          title: '销售运费',
          field: 'freight_fees_bill',
          suffix: '元',
          fnChange: () => {
            math.totalFormData(this.detailData) // 计算-表格汇总计算
          }
        },
        {
          type: 'number',
          title: '打包费',
          field: 'pack_fees_bill',
          suffix: '元',
          fnChange: () => {
            math.totalFormData(this.detailData) // 计算-表格汇总计算
          }
        },
        {
          type: 'number',
          title: '其他费用',
          field: 'other_fees_bill',
          suffix: '元',
          fnChange: () => {
            math.totalFormData(this.detailData) // 计算-表格汇总计算
          }
        },
        {
          type: 'number',
          title: '费用合计',
          field: 'fees_total',
          suffix: '元',
          placeholder: '自动计算',
          disabled: true
        }
      ],
      formColumn3: [
        {
          title: '含税销售金额',
          field: 'sales_amount_total',
          suffix: '元'
        },
        {
          title: '未税销售金额',
          field: 'wei_shui_sales_amount_total',
          suffix: '元'
        },
        {
          title: '订单税金',
          field: 'tax_fees_total',
          suffix: '元'
        },
        {
          title: '订单成本',
          field: 'cost_price_total',
          suffix: '元'
        },
        {
          title: '订单利润',
          field: 'profit_total',
          suffix: '元'
        },
        {
          title: '订单利润率',
          field: 'profit_rate_total',
          suffix: '%'
        },
        {
          title: '提成金额',
          field: 'push_money',
          suffix: '元'
        }
      ],
      formColumn4: [
        {
          type: 'text',
          title: '一、包装方式',
          field: 'package_type',
          placeholder: '包装方式'
        },
        {
          type: 'text',
          title: '二、合同履行地',
          field: 'pact_action_address',
          placeholder: '合同履行地'
        },
        {
          type: 'text',
          title: '三、运输方式',
          field: 'transport',
          placeholder: '运输方式'
        },
        {
          type: 'text',
          title: '四、付款方式',
          field: 'pay',
          placeholder: '付款方式'
        },
        {
          type: 'text',
          title: '五、产品执行标准',
          field: 'quality_action',
          placeholder: '产品执行标准'
        },
        {
          type: 'text',
          title: '六、产品验收标准',
          field: 'quality_check',
          placeholder: '产品验收标准'
        },
        {
          type: 'text',
          title: '七、违约责任',
          field: 'break_pact',
          placeholder: '违约责任'
        },
        {
          type: 'text',
          title: '八、争议解决',
          field: 'dispute_resolution',
          placeholder: '争议解决'
        },
        {
          type: 'text',
          title: '九、合同生效说明',
          field: 'pact_effect',
          placeholder: '合同生效说明'
        }
      ],

      detailData: {
        formData: {
          version: 2,
          bill_date: this.$XEUtils.toDateString(this.$XEUtils.now(), 'yyyy-MM-dd'), // 销售日期
          bill_code: '', // 销售单号
          saler_id: '', // 业务员id
          saler_name: '', // 业务员
          commission_rate: '', // 提成比例
          company_name: '', // 客户
          company_id: '', // 客户id
          company_uuid: '', // 客户uuid
          saler_company_name: this.$constant.company_info.company_name, // 开单公司
          ding_dan_lei_xing: '销售订单', // 订单类型
          jiao_huo_ri_qi: '', // 交货日期
          fu_jian_list: [], // 附件文档
          xiang_mu_ming_cheng: '', // 项目名称
          bill_remark: '', // 单据备注
          has_freight: false, // 是否含运
          freight_fees_bill: '', // 销售运费
          pack_fees_bill: '', // 打包费
          other_fees_bill: '', // 其他费用
          bill_tax_rate: '', // 税率
          tax_fees_total: '', // 税金
          fees_total: '', // 费用合计
          sales_amount_total: '', // 含税销售金额
          wei_shui_sales_amount_total: '', // 未税销售金额
          cost_price_total: '', // 订单成本
          profit_total: '', // 订单利润
          profit_rate_total: '', // 订单利润率
          push_money: '', // 提成金额
          status_str: ''
        },
        tableSaleData: [],
        pact_bill: {}
      }, // 详情数据
      detailTimer: null, // 详情数据更新计时器

      customerList: [],
      isShowPopupCustomer: false,
      isShowPopupVerifyGoodsDetail: false, // 制造明细
      activeCustomerId: null
    }
  },
  computed: {
    maxHeight() {
      let result = `${this.$util.getViewHeight() - 440}px`
      return result
    },
    isSelfDisabled() {
      let { status_str } = this.detailData.formData
      let isVerify = status_str === '' || status_str === '暂存' || status_str === '已驳回'
      let isChuangJianDo = isVerify && this.isChuangJian
      let isFuZeDo = this.isFuZe
      let result = !(isChuangJianDo || isFuZeDo)
      return result
    },
    selfAccountData() {
      let result = this.$store.getters.getLoginAccount
      return result
    }
  },
  watch: {
    'detailData.tableSaleData': {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
            if (this.detailTimer) {
              clearTimeout(this.detailTimer)
            }
            this.detailTimer = setTimeout(() => {
              math.totalDetailData(this.detailData) // 计算-汇总详情
              this.detailTimer = null
            }, 100)
          }
        })
      },
      deep: true
    },
    'detailData.formData.bill_tax_rate': {
      handler(newVal = '', oldVal = '') {
        if (newVal !== oldVal) math.totalDetailData(this.detailData)
      },
      deep: true
    },
    'detailData.formData.company_id': {
      handler(newVal = '', oldVal = '') {
        if (newVal !== oldVal) {
          this.formColumn1.forEach((itemColumn) => {
            if (itemColumn.field === 'company_id') itemColumn.filterable = !newVal
          })
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.loaded = false
    // 初始化-新增客户
    this.formColumn1.forEach((item) => {
      if (item.field === 'company_id') {
        item.optionDo.fn = this.customerEdit
        item.emptyDo.fn = this.customerAdd
        item.disabled = !this.isChuangJian
      }
    })

    if (this.id) {
      this.getDetailData()
    } else {
      this.detailData.formData.saler_id = this.selfAccountData.id // 初始化-业务员id
      this.detailData.formData.saler_name = this.selfAccountData.nick_name // 初始化-业务员
      this.detailData.formData.commission_rate = this.selfAccountData.commission_rate // 初始化-提成比例
      this.detailData.tableSaleData = [this.$util.deepCopy(this.$constant.newTableSaleObj)] // 初始化-数据结构
      this.detailData.tableSaleData[0].name = '商品1'
      this.getSaleList()
      this.getCustomerList()
      this.getInitData()
      this.loaded = true
    }
  },
  methods: {
    // 获取-详情数据
    getDetailData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/detail',
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = this.$util.deepCopy(res.data)
          result.formData.fu_jian_list = result.formData.fu_jian_list || []
          result.formData.has_freight = result.formData.has_freight || false // 是否含运，无该字段时补充，避免数据变更无法响应更新
          this.detailData = this.$util.deepCopy(result)
          this.getSaleList()
          this.getCustomerList()
          this.loaded = true
        }
      })
    },
    // 获取-初始数据
    getInitData() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/pack2/chuShiHuaHeTong'
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result1 = this.$util.deepCopy(res.data.pact_bill)
          let result2 = {
            saler: this.selfAccountData.nick_name,
            saler_name: this.selfAccountData.nick_name,
            saler_id: this.selfAccountData.id,
            saler_phone: this.selfAccountData.user_name
          }
          this.detailData.pact_bill = { ...this.detailData.pact_bill, ...result1, ...result2 }
          this.getSaleList()
          this.getCustomerList()
        }
      })
    },
    // 获取业务员列表
    getSaleList() {
      this.$api({
        method: 'post',
        url: '/admin/account/getAccountList',
        data: {
          filterData: {
            role_name: '业务员'
          },
          pageSize: this.$constant.pageMax
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          let result = res.data.page.list.map((item) => {
            return {
              key: item.nick_name,
              val: item.id
            }
          })

          // 不存在当前账户id，则增加到下拉
          let selfAccountObj = {
            key: this.selfAccountData.nick_name,
            val: this.selfAccountData.id
          }
          let isExistAccount = result.some((item) => {
            return item.val === selfAccountObj.val
          })
          if (!isExistAccount) result.unshift(selfAccountObj)

          // 不存在已选业务员，增加到下拉
          let selfOrderObj = {
            key: this.detailData.formData.saler_name,
            val: this.detailData.formData.saler_id
          }
          let isExistOrder = result.some((item) => {
            return item.val === selfOrderObj.val
          })
          if (!isExistOrder && !!selfOrderObj.val && selfAccountObj.val !== selfOrderObj.val) {
            result.unshift(selfOrderObj)
          }

          // 初始化-业务员
          this.formColumn1.forEach((item) => {
            if (item.field === 'saler_id') item.options = this.$util.deepCopy(result)
          })
          if (!this.detailData.formData.saler_id) {
            result.forEach((item) => {
              if (item.val === selfAccountObj.val) {
                this.detailData.formData.saler_name = item.key // 初始化-业务员
                this.detailData.formData.saler_id = item.val // 初始化-业务员id
              }
            })
          }

          this.saleList = result
        } else {
          return
        }
      })
    },
    // 获取客户列表
    getCustomerList(isFilter = false) {
      this.formColumn1.forEach((itemColumn) => {
        if (itemColumn.field === 'company_id') {
          if (!isFilter) itemColumn.hide = true
          let filterData = {
            // saler_id: this.detailData.formData.saler_id
          }
          let id = this.detailData.formData.company_id
          if (id) {
            this.customerKeyword = ''
            filterData.id = id
          }
          this.$api({
            method: 'post',
            url: '/admin/customers/search',
            data: {
              keyword: this.customerKeyword,
              filterData,
              sortData: {
                last_gen_jin_date: 'desc'
              },
              pageSize: 200
            }
          }).then((res) => {
            if (res.data.state === 'ok') {
              let result = res.data.page.list.map((item) => {
                return {
                  key: item.customer_name,
                  val: item.id,
                  data: this.$util.deepCopy(item)
                }
              })
              this.customerList = result
              itemColumn.options = this.$util.deepCopy(result)
              if (!isFilter) itemColumn.hide = false
            }
          })
        }
      })
    },
    // 客户新增
    customerAdd() {
      let refForm1 = this.$refs.refForm1
      refForm1.$refs.company_id[0].blur()
      this.activeCustomerId = null
      this.isShowPopupCustomer = true
    },
    // 客户编辑
    customerEdit(data) {
      this.activeCustomerId = data.val
      this.isShowPopupCustomer = true
    },
    // 客户更新
    customerUpdate(val) {
      this.detailData.formData.company_name = val.customer_name
      this.detailData.formData.company_id = val.id
      this.detailData.formData.company_uuid = val.company_uuid
      this.getCustomerList()
    },
    // 客户选择
    customerChoose() {
      let id = this.detailData.formData.company_id
      if (id) {
        this.customerList.forEach((item) => {
          if (item.val === id) {
            this.detailData.formData.company_name = item.key
            this.detailData.formData.company_uuid = item.data.company_uuid
          }
        })
      } else {
        this.detailData.formData.company_name = ''
        this.detailData.formData.company_uuid = ''
      }
      this.getCustomerList()
    },
    // 详情更新has_bom
    detailUpdateHasBom(list) {
      list.forEach((item) => {
        let has_bom = !!item.tableBomData.length
        item.has_bom = has_bom
        item.table_data_1[0].has_bom = has_bom
        if (has_bom) {
          this.detailUpdateHasBom(item.tableBomData)
        }
      })
    },
    // 详情-保存
    detailSave(isPrompt) {
      if (!this.detailData.formData.bill_date) {
        this.$message.error('请选择销售日期')
        return
      }
      if (!this.detailData.formData.jiao_huo_ri_qi) {
        this.$message.error('请选择交货日期')
        return
      }
      this.$refs.refForm1.$refs.refForm.validate((valid) => {
        if (valid) {
          let data = this.$util.deepCopy(this.detailData)
          this.detailUpdateHasBom(data.tableSaleData)
          this.$api({
            method: 'post',
            url: '/admin/gcvip/checkBill2/saveOrUpdate',
            data
          }).then((res) => {
            if (res.data.state === 'ok') {
              let id = res.data.id
              this.$emit('update:id', id)
              if (isPrompt) this.$message.success('操作成功')
              if (this.isDetailPush) {
                this.isDetailPush = false
                this.detailPushConfirm(id)
                return
              }
              if (this.isDetailPrint) {
                this.isDetailPrint = false
                this.detailPrintConfirm(id)
                return
              }
              if (!this.id) this.popupCancel()
            }
          })
        }
      })
    },
    // 详情-生成合同
    detailPush() {
      if (this.isSelfDisabled) {
        this.detailPushConfirm(this.id)
      } else {
        this.isDetailPush = true
        this.detailSave()
      }
    },
    // 详情-生成合同-确认
    detailPushConfirm() {
      this.$emit('jump', 'Contract')
    },
    // 详情-驳回
    detailReject() {
      this.$confirm(`销售单号:${this.detailData.formData.bill_code}，该核算单是否驳回审核?`, '提示')
        .then(() => {
          this.detailRejectConfirm()
        })
        .catch(() => {})
    },
    // 详情-驳回-确认
    detailRejectConfirm() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/leaderReject',
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已驳回审核')
        }
      })
    },
    // 详情-通过
    detailPass() {
      this.$confirm(`销售单号:${this.detailData.formData.bill_code}，该核算单是否通过审核?`, '提示')
        .then(() => {
          this.detailPassConfirm()
        })
        .catch(() => {})
    },
    // 详情-通过-确认
    detailPassConfirm() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/leaderDoAudit',
        params: {
          id: this.id
        }
      }).then((res) => {
        if (res.data.state === 'ok') {
          this.$message.success('已通过审核')
        }
      })
    },
    // 详情-打印
    detailPrint() {
      if (this.isSelfDisabled) {
        this.detailPrintConfirm(this.id)
      } else {
        this.isDetailPrint = true
        this.detailSave()
      }
    },
    // 详情-打印-确认
    detailPrintConfirm(id) {
      window.open(`/new/verify/print/verify?id=${id}`, '_blank')
    },
    // 制造明细
    openPopupVerifyGoodsDetail() {
      this.isShowPopupVerifyGoodsDetail = true
    },
    // 项-引用新增
    itemCopy() {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/checkBill2/copy',
        params: {
          id: this.id
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('引用新增成功')
            this.$emit('update:id', res.data.id)
            this.getDetailData()
          }
        })
        .catch(() => {})
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDo(val.row.bill_id)
    },
    // 设置税率
    setTaxRate() {
      this.detailData.formData.bill_tax_rate = 0
      this.detailData.tableSaleData.forEach((item) => {
        item.sales_price = item.wei_shui_sales_price
      })
      math.totalDetailData(this.detailData) // 计算-汇总详情
    },
    // 弹窗取消
    popupCancel() {
      this.$emit('success')
    }
  }
}
</script>

<style lang="less" scoped>
.cont-main {
  display: flex;
  flex-direction: column;
  .table-main {
    position: relative;
    border: 1px solid #e8eaec;
    .link-total-detail {
      position: absolute;
      top: 8px;
      left: 85px;
      font-size: 14px;
      font-weight: bold;
      z-index: 99;
    }
    .form-5 {
      display: flex;
      align-items: center;
      position: absolute;
      top: 2px;
      left: 705px;
      z-index: 99;
      /deep/ .el-input-group__prepend {
        color: @colorGrayDeep;
      }
    }
    .total-item {
      & ~ .total-item {
        margin-left: 10px;
      }
      .total-item-price {
        padding: 0 5px;
        font-weight: bold;
        font-size: 14px;
        color: @colorRed;
      }
    }
  }

  .cont-form {
    display: flex;
    margin-top: 10px;
    border: 1px solid #e8eaec;

    .form-title {
      font-size: 14px;
      color: @colorGreen;
      font-weight: bold;
      line-height: 28px;
      padding: 5px 5px 0 5px;
    }
    .form-list {
      padding: 5px;
      flex: 1;
    }
    /deep/ .el-form-item {
      margin-bottom: 5px;
    }
    /deep/ .el-form-item__label {
      line-height: 24px;
    }
    /deep/ .el-form-item__content {
      height: 24px;
      line-height: 24px;
    }
    /deep/ .el-input__inner {
      height: 24px;
      line-height: 24px;
    }
    /deep/ .el-input__icon {
      line-height: 24px;
    }
  }

  .total-main {
    margin: 10px 0;
    font-size: 12px;
    color: #606266;
    .total-item {
      margin-right: 20px;
      .total-item-price {
        padding: 0 5px;
        font-weight: bold;
        font-size: 14px;
        color: @colorRed;
      }
    }
  }
}
</style>
